import { PublicClientApplication, type Configuration, LogLevel } from '@azure/msal-browser';

// SPA app registration produced by scripts/register-app.ps1 on 2026-06-01.
// Non-secret values; same IDs in infra/parameters.json and infra/main.bicep.
// Phase 2 can move these behind VITE_CONF_* env vars if CI needs per-env
// overrides; for Phase 1, hardcoded is the path of least resistance.
const TENANT_ID = 'a153cdf7-75ab-4b2e-8a5f-257ea0add5ec';
const SPA_CLIENT_ID = 'e7746cd1-77cf-442f-8e36-05654ffa0046';

export const msalConfig: Configuration = {
  auth: {
    clientId: SPA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // sessionStorage: survives reload, dies on tab close. Safer for admin UI
    // than localStorage. The kiosk view never signs in, so this only affects
    // /admin and /rooms.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (_lvl, msg) => console.debug(`[msal] ${msg}`),
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

// Login scopes. The custom api scope is what gives the resulting token an
// audience the API can validate. openid/profile/email are needed for the
// user-info claims we display.
export const loginRequest = {
  scopes: [`api://${SPA_CLIENT_ID}/Rooms.Read`, 'openid', 'profile', 'email'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
